import React from 'react'

import ReactDOM from 'react-dom'

import { instance as instanceNR } from '@psdhub/newrelic'
import getSiteControlInit from '@psdhub/gsc'

import history from '~/services/history'

import { clearAllStorage } from './services/clearAllStorage'
import App from './App'

instanceNR()
getSiteControlInit(history)
clearAllStorage()

ReactDOM.render(<App />, document.getElementById('hub-psd'))
